import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const C = {
  brand: "#141719", brandMid: "#1C1F22", surface: "#1A1D20",
  gold: "#C9A84C", goldLight: "#D4B96A", goldMuted: "rgba(201,168,76,0.10)", goldDark: "#A88B3D",
  cream: "#FAFAF7", white: "#FFFFFF",
  g50: "#F7F7F5", g100: "#EEEDE9", g200: "#E0DED8", g300: "#CCCAC3",
  g400: "#9B9890", g500: "#6E6B64", g600: "#4A4843", g700: "#333130", g900: "#1A1815",
  green: "#3B9B5E", greenBg: "rgba(59,155,94,0.08)", greenSoft: "rgba(59,155,94,0.15)",
  amber: "#D4952B", amberBg: "rgba(212,149,43,0.08)", amberSoft: "rgba(212,149,43,0.15)",
  red: "#C4463A", redBg: "rgba(196,70,58,0.08)", redSoft: "rgba(196,70,58,0.12)",
  blue: "#3A7BD5", blueBg: "rgba(58,123,213,0.08)",
};

const playfair = "'Playfair Display', Georgia, serif";
const sans = "'DM Sans', 'Inter', -apple-system, sans-serif";

const Icon = {
  grid: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  calendar: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>,
  wine: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M8 22h8M12 13v9M7.75 2h8.5l.75 6a5.25 5.25 0 1 1-10 0L7.75 2z"/></svg>,
  chat: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  book: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  dollar: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  logout: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  bell: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  send: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  download: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  clock: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  alert: <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  arrowRight: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>,
  home: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  gear: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/></svg>,
  check: <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>,
  file: <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
};

const LOCKER = [
  { name: "Clase Azul Reposado", type: "Tequila", remaining: 65, unit: "%" },
  { name: "Pappy Van Winkle 15yr", type: "Bourbon", remaining: 30, unit: "%" },
  { name: "Dom Pérignon 2015", type: "Champagne", remaining: 2, unit: "btl" },
  { name: "Opus One 2019", type: "Red Wine", remaining: 1, unit: "btl" },
  { name: "Macallan 18yr", type: "Scotch", remaining: 80, unit: "%" },
];

const EVENTS = [
  { id: 1, title: "Bourbon & Business Networking", date: "Oct 29", day: "Thursday", time: "7:00 PM", location: "The Medina Lounge", spots: 12, tag: "Networking", desc: "An evening of small-batch bourbon and conversation with fellow members and their guests." },
  { id: 2, title: "Medina Experiences · Chapter Two", date: "Nov 5", day: "Thursday", time: "5:30 PM", location: "To be announced", spots: 30, tag: "Professional", desc: "The next member-led chapter. Speaker and topic to be announced." },
  { id: 3, title: "Members-Only Wine Dinner", date: "Nov 12", day: "Thursday", time: "7:30 PM", location: "Chef's Table", spots: 4, tag: "Dining", desc: "A seated, five-course dinner paired with wines selected for the evening." },
  { id: 4, title: "Hard-Hat Preview · Snell Arcade", date: "Nov 19", day: "Thursday", time: "4:00 PM", location: "Snell Arcade", spots: 10, tag: "Culture", desc: "A guided walk through the house as construction progresses. Closed-toe shoes required." },
];

const SPACES = [
  { name: "Cinema Room", tag: "ENTERTAINMENT", img: "/cinema-room.jpg", desc: "An intimate screening room with plush seating, craft cocktails, and a curated film experience for up to 12 guests.", capacity: 12 },
  { name: "Golf Simulator", tag: "RECREATION", img: "/golf-simulator.jpg", desc: "A private simulator suite with premium lounge seating, full bar service, and world-class courses at your fingertips.", capacity: 6 },
  { name: "Conference Room", tag: "BUSINESS", img: "/conference-room.jpg", desc: "A striking marble-topped boardroom with seating for 10, ideal for private meetings, closings, and intimate dinners.", capacity: 10 },
];

const LOCKER_HISTORY = [
  { date: "Oct 9", item: "Macallan 18yr", detail: "2 pours" },
  { date: "Oct 2", item: "Clase Azul Reposado", detail: "3 pours" },
  { date: "Sep 23", item: "Dom Pérignon 2015", detail: "1 bottle" },
  { date: "Sep 18", item: "Pappy Van Winkle 15yr", detail: "2 pours" },
];

const PAYMENTS = [
  { date: "Oct 1, 2026", desc: "Membership dues", amount: "$8,500", status: "Paid" },
  { date: "Sep 1, 2026", desc: "Membership dues", amount: "$8,500", status: "Paid" },
  { date: "Aug 1, 2026", desc: "Membership dues", amount: "$8,500", status: "Paid" },
  { date: "Jan 15, 2026", desc: "Initiation fee", amount: "—", status: "Paid" },
];

const HANDBOOK = [
  { title: "House Hours", body: "Hours will be published ahead of opening at the Snell Arcade. Pre-opening gatherings are announced individually by email and on the Events page." },
  { title: "Guests", body: "Members may bring one guest to most gatherings unless an invitation states otherwise. Members are responsible for their guests while in the house." },
  { title: "Dress & Conduct", body: "The house standard will be shared in the full handbook. In the spirit of Medina, we ask members to be present, considerate, and generous with one another." },
  { title: "Phones & Privacy", body: "Photographs of members and guests should not be shared without consent. Calls are welcome in designated areas once the house opens." },
  { title: "Reservations & Spaces", body: "The Cinema Room, Golf Simulator, and Conference Room are reserved through the Spaces page. Requests are confirmed by the team." },
  { title: "Lockers", body: "Members may keep wine and spirits in a personal locker. Pours are recorded by the bar team and reflected on the My Locker page." },
  { title: "Dues & Billing", body: "Dues are billed on the first of each billing period. Questions about your account can be sent to Member Services through Messages." },
];

const INITIAL_THREADS = [
  { id: "concierge", name: "Concierge", sub: "Reservations, requests, anything else", messages: [
    { from: "staff", text: "Welcome to the member portal. Reach us here any time for reservations, requests, or questions.", time: "Oct 12" },
  ] },
  { id: "beverage", name: "Beverage Service", sub: "Locker, pours, and bar requests", messages: [
    { from: "staff", text: "Your Pappy Van Winkle 15yr is running low. Would you like us to source a replacement bottle?", time: "Oct 10" },
  ], unread: true },
  { id: "member", name: "Member Services", sub: "Dues, account, and guest passes", messages: [
    { from: "staff", text: "Thank you, your October dues payment has been received.", time: "Oct 1" },
  ], unread: true },
];

const tagColor = { Networking: C.blue, Culture: C.amber, Dining: C.green, Professional: C.gold };

function LockerBar({ pct }) {
  const color = pct > 50 ? C.green : pct > 20 ? C.amber : C.red;
  return (
    <div style={{ width: "100%", height: 6, background: C.g100, borderRadius: 3, overflow: "hidden" }}>
      <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 3 }} />
    </div>
  );
}

function Card({ children, style = {} }) {
  return <div style={{ background: C.white, borderRadius: 10, border: `1px solid ${C.g100}`, ...style }}>{children}</div>;
}

function CardHeader({ title, icon, actionLabel, action }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 22px", borderBottom: `1px solid ${C.g100}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {icon && <span style={{ color: C.gold, display: "flex" }}>{icon}</span>}
        <h3 style={{ fontSize: 14, fontWeight: 600, color: C.g900, fontFamily: sans }}>{title}</h3>
      </div>
      {action && <button onClick={action} style={{ background: "none", border: "none", color: C.gold, fontSize: 12.5, fontWeight: 500, cursor: "pointer", fontFamily: sans, display: "flex", alignItems: "center", gap: 4 }}>{actionLabel} {Icon.arrowRight}</button>}
    </div>
  );
}

// ═══════════════════════════════════════════════════
// SHARED PAGE PIECES
// ═══════════════════════════════════════════════════
const btnDark = { padding: "9px 18px", borderRadius: 6, border: "none", background: C.brand, color: C.white, fontSize: 13, fontWeight: 600, fontFamily: sans, cursor: "pointer" };
const btnLight = { padding: "9px 18px", borderRadius: 6, border: `1px solid ${C.g200}`, background: C.white, color: C.g900, fontSize: 13, fontWeight: 500, fontFamily: sans, cursor: "pointer" };
const inputStyle = { width: "100%", padding: "10px 12px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, fontFamily: sans, background: C.white, boxSizing: "border-box" };

function PageTitle({ title, sub }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h1 style={{ fontSize: 28, fontWeight: 400, color: C.g900, fontFamily: playfair, marginBottom: 4 }}>{title}</h1>
      {sub && <p style={{ fontSize: 14, color: C.g400 }}>{sub}</p>}
    </div>
  );
}

function Notice({ text, onClose }) {
  if (!text) return null;
  return (
    <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)", background: C.brand, color: C.white, padding: "12px 20px", borderRadius: 8, fontSize: 13.5, zIndex: 200, display: "flex", gap: 14, alignItems: "center", boxShadow: "0 8px 24px rgba(0,0,0,0.2)", maxWidth: "90vw" }}>
      <span style={{ color: C.gold, display: "flex" }}>{Icon.check}</span>{text}
      <button onClick={onClose} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.5)", fontSize: 16, cursor: "pointer" }}>×</button>
    </div>
  );
}

function Tag({ label }) {
  const col = tagColor[label] || C.g600;
  return <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 4, letterSpacing: 0.5, color: col, background: `${col}15` }}>{label.toUpperCase()}</span>;
}

function DateBadge({ date }) {
  return (
    <div style={{ width: 52, height: 58, borderRadius: 8, background: C.goldMuted, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <span style={{ fontSize: 18, fontWeight: 700, color: C.gold, lineHeight: 1 }}>{date.split(" ")[1]}</span>
      <span style={{ fontSize: 10, color: C.goldDark, textTransform: "uppercase", fontWeight: 600, marginTop: 2 }}>{date.split(" ")[0]}</span>
    </div>
  );
}

// ═══════════════════════════════════════════════════
// EVENTS
// ═══════════════════════════════════════════════════
function EventsPage({ rsvps, toggleRsvp }) {
  const [filter, setFilter] = useState("All");
  const types = ["All", ...Array.from(new Set(EVENTS.map(e => e.tag)))];
  const list = filter === "All" ? EVENTS : EVENTS.filter(e => e.tag === filter);
  return (
    <>
      <PageTitle title="Events" sub="Gatherings for members and their guests" />
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 }}>
        {types.map(t => (
          <button key={t} onClick={() => setFilter(t)} style={{ ...btnLight, padding: "6px 14px", fontSize: 12.5, background: filter === t ? C.brand : C.white, color: filter === t ? C.white : C.g600, borderColor: filter === t ? C.brand : C.g200 }}>{t}</button>
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {list.map(ev => {
          const going = rsvps.includes(ev.id);
          const spots = ev.spots - (going ? 1 : 0);
          return (
            <Card key={ev.id}>
              <div style={{ display: "flex", gap: 18, padding: 20, alignItems: "flex-start", flexWrap: "wrap" }}>
                <DateBadge date={ev.date} />
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ marginBottom: 6 }}><Tag label={ev.tag} /></div>
                  <div style={{ fontSize: 18, fontFamily: playfair, color: C.g900, marginBottom: 6 }}>{ev.title}</div>
                  <div style={{ fontSize: 12.5, color: C.g400, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>{Icon.clock} {ev.day}, {ev.time}</span><span>·</span><span>{ev.location}</span>
                  </div>
                  <p style={{ fontSize: 13.5, color: C.g500, lineHeight: 1.55 }}>{ev.desc}</p>
                </div>
                <div style={{ textAlign: "right", minWidth: 130 }}>
                  <button onClick={() => toggleRsvp(ev.id)} style={going ? { ...btnLight, color: C.green, borderColor: C.greenSoft, background: C.greenBg } : btnDark}>
                    {going ? "✓ Attending" : "RSVP"}
                  </button>
                  <div style={{ fontSize: 11.5, color: spots <= 5 ? C.red : C.g400, marginTop: 8 }}>{spots} spots left</div>
                  {going && <div style={{ fontSize: 11, color: C.g400, marginTop: 4 }}>Tap again to cancel</div>}
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════
// LOCKER
// ═══════════════════════════════════════════════════
function LockerPage({ notify }) {
  const [pourItem, setPourItem] = useState(LOCKER[0].name);
  const [pourNote, setPourNote] = useState("");
  return (
    <>
      <PageTitle title="My Locker" sub="Your wine and spirits held at the house" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 14, marginBottom: 20 }}>
        {LOCKER.map((item, i) => {
          const pct = item.unit === "%" ? item.remaining : item.remaining > 2 ? 80 : Math.max(item.remaining * 30, 15);
          const isLow = (item.unit === "%" && item.remaining <= 30) || (item.unit === "btl" && item.remaining <= 1);
          return (
            <Card key={i} style={{ padding: 18, border: isLow ? `1px solid ${C.amberSoft}` : `1px solid ${C.g100}` }}>
              <div style={{ fontSize: 11, color: C.g400, textTransform: "uppercase", letterSpacing: 1, fontWeight: 600, marginBottom: 6 }}>{item.type}</div>
              <div style={{ fontSize: 15, fontWeight: 600, color: C.g900, marginBottom: 14, minHeight: 38 }}>{item.name}</div>
              <LockerBar pct={pct} />
              <div style={{ display: "flex", justifyContent: "space-between", margin: "8px 0 14px" }}>
                <span style={{ fontSize: 12, color: C.g500 }}>{item.remaining}{item.unit === "%" ? "% remaining" : ` bottle${item.remaining !== 1 ? "s" : ""}`}</span>
                {isLow && <span style={{ fontSize: 10.5, fontWeight: 700, color: C.amber }}>LOW</span>}
              </div>
              <button onClick={() => notify(`Restock request sent for ${item.name}`)} style={{ ...btnLight, width: "100%", padding: "7px 0", fontSize: 12 }}>Request Restock</button>
            </Card>
          );
        })}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 18 }}>
        <Card>
          <CardHeader title="Request a Pour" icon={Icon.wine} />
          <div style={{ padding: 22 }}>
            <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>From your locker</label>
            <select value={pourItem} onChange={e => setPourItem(e.target.value)} style={{ ...inputStyle, marginBottom: 14 }}>
              {LOCKER.map(l => <option key={l.name}>{l.name}</option>)}
            </select>
            <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>Notes</label>
            <input value={pourNote} onChange={e => setPourNote(e.target.value)} placeholder="Neat, on the rocks, table number..." style={{ ...inputStyle, marginBottom: 16 }} />
            <button onClick={() => { notify(`Pour of ${pourItem} requested. The bar team has been notified.`); setPourNote(""); }} style={{ ...btnDark, width: "100%" }}>Send to Bar</button>
          </div>
        </Card>
        <Card>
          <CardHeader title="Recent Activity" icon={Icon.clock} />
          {LOCKER_HISTORY.map((h, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "13px 22px", borderBottom: i < LOCKER_HISTORY.length - 1 ? `1px solid ${C.g100}` : "none" }}>
              <div>
                <div style={{ fontSize: 13.5, color: C.g900, fontWeight: 500 }}>{h.item}</div>
                <div style={{ fontSize: 12, color: C.g400 }}>{h.detail}</div>
              </div>
              <span style={{ fontSize: 12, color: C.g400 }}>{h.date}</span>
            </div>
          ))}
        </Card>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════
// DUES
// ═══════════════════════════════════════════════════
function DuesPage({ notify }) {
  const [autopay, setAutopay] = useState(true);
  const [showPay, setShowPay] = useState(false);
  return (
    <>
      <PageTitle title="Dues" sub="Your membership account" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14, marginBottom: 20 }}>
        {[
          { label: "Next Payment", value: "$8,500", sub: "Due November 1, 2026" },
          { label: "Account Status", value: "Current", sub: "No balance outstanding", color: C.green },
          { label: "Membership Renewal", value: "Jan 15, 2027", sub: "Annual renewal date" },
        ].map((s, i) => (
          <Card key={i} style={{ padding: 20 }}>
            <div style={{ fontSize: 11, color: C.g400, textTransform: "uppercase", letterSpacing: 1, fontWeight: 600, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 24, fontFamily: playfair, color: s.color || C.g900, marginBottom: 4 }}>{s.value}</div>
            <div style={{ fontSize: 12.5, color: C.g400 }}>{s.sub}</div>
          </Card>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 18 }}>
        <Card>
          <CardHeader title="Payment" icon={Icon.dollar} />
          <div style={{ padding: 22 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0 16px", borderBottom: `1px solid ${C.g100}`, marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 13.5, color: C.g900, fontWeight: 500 }}>Automatic payments</div>
                <div style={{ fontSize: 12, color: C.g400 }}>Charge dues on the due date</div>
              </div>
              <button onClick={() => { setAutopay(!autopay); notify(autopay ? "Automatic payments turned off" : "Automatic payments turned on"); }}
                style={{ width: 44, height: 24, borderRadius: 12, border: "none", background: autopay ? C.green : C.g300, position: "relative", cursor: "pointer" }}>
                <span style={{ position: "absolute", top: 3, left: autopay ? 23 : 3, width: 18, height: 18, borderRadius: "50%", background: C.white, transition: "left 0.15s" }} />
              </button>
            </div>
            <div style={{ fontSize: 13, color: C.g500, marginBottom: 16 }}>Payment method on file: <strong style={{ color: C.g900 }}>Card ending 4417</strong></div>
            <button onClick={() => setShowPay(true)} style={{ ...btnDark, width: "100%" }}>Pay Now</button>
            {showPay && (
              <div style={{ marginTop: 14, padding: 14, borderRadius: 8, background: C.goldMuted, fontSize: 13, color: C.g700, lineHeight: 1.5 }}>
                Online payment is being set up. In the meantime, Member Services can process your payment. Send them a note through Messages.
              </div>
            )}
          </div>
        </Card>
        <Card>
          <CardHeader title="Payment History" icon={Icon.clock} />
          {PAYMENTS.map((p, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 22px", borderBottom: i < PAYMENTS.length - 1 ? `1px solid ${C.g100}` : "none" }}>
              <div>
                <div style={{ fontSize: 13.5, color: C.g900, fontWeight: 500 }}>{p.desc}</div>
                <div style={{ fontSize: 12, color: C.g400 }}>{p.date}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 13.5, color: C.g900, fontWeight: 600 }}>{p.amount}</div>
                <div style={{ fontSize: 11, color: C.green, fontWeight: 600 }}>{p.status.toUpperCase()}</div>
              </div>
            </div>
          ))}
        </Card>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════
// DOCUMENTS (live data)
// ═══════════════════════════════════════════════════
function DocumentsPage({ docs, download, fmtDate, fmtSize }) {
  return (
    <>
      <PageTitle title="Documents" sub="Statements and files shared with you by the Medina team" />
      <Card>
        {docs.length === 0 ? (
          <div style={{ padding: "48px 24px", textAlign: "center", color: C.g400, fontSize: 14 }}>
            <div style={{ color: C.g300, display: "flex", justifyContent: "center", marginBottom: 10 }}>{Icon.file}</div>
            No documents yet. Anything the team shares with you will appear here.
          </div>
        ) : docs.map((d, i) => (
          <div key={d.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "15px 22px", borderBottom: i < docs.length - 1 ? `1px solid ${C.g100}` : "none", flexWrap: "wrap" }}>
            <div style={{ display: "flex", gap: 14, alignItems: "center", minWidth: 0 }}>
              <span style={{ color: C.gold, display: "flex" }}>{Icon.file}</span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 500, color: C.g900, wordBreak: "break-word" }}>{d.originalName}</div>
                <div style={{ fontSize: 12, color: C.g400 }}>{d.docType} · {fmtDate(d.uploadedAt)} · {fmtSize(d.fileSize)}</div>
              </div>
            </div>
            <button onClick={() => download(d)} style={{ ...btnDark, padding: "7px 16px", fontSize: 12, display: "flex", gap: 6, alignItems: "center" }}>{Icon.download} Download</button>
          </div>
        ))}
      </Card>
    </>
  );
}

// ═══════════════════════════════════════════════════
// MESSAGES
// ═══════════════════════════════════════════════════
function MessagesPage({ threads, setThreads, isMobile }) {
  const [active, setActive] = useState(threads[0].id);
  const [draft, setDraft] = useState("");
  const thread = threads.find(t => t.id === active);

  useEffect(() => {
    setThreads(ts => ts.map(t => t.id === active ? { ...t, unread: false } : t));
  }, [active, setThreads]);

  const send = () => {
    if (!draft.trim()) return;
    const text = draft.trim();
    setDraft("");
    setThreads(ts => ts.map(t => t.id === active ? { ...t, messages: [...t.messages, { from: "me", text, time: "Just now" }] } : t));
    setTimeout(() => {
      setThreads(ts => ts.map(t => t.id === active ? { ...t, messages: [...t.messages, { from: "staff", text: "Thank you. A member of our team will follow up with you shortly.", time: "Just now" }] } : t));
    }, 1200);
  };

  return (
    <>
      <PageTitle title="Messages" sub="Reach the Medina team directly" />
      <Card style={{ display: "flex", flexDirection: isMobile ? "column" : "row", minHeight: 480, overflow: "hidden" }}>
        <div style={{ width: isMobile ? "100%" : 260, borderRight: isMobile ? "none" : `1px solid ${C.g100}`, borderBottom: isMobile ? `1px solid ${C.g100}` : "none" }}>
          {threads.map(t => (
            <button key={t.id} onClick={() => setActive(t.id)} style={{ display: "block", width: "100%", textAlign: "left", padding: "14px 18px", border: "none", borderBottom: `1px solid ${C.g100}`, background: active === t.id ? C.goldMuted : C.white, cursor: "pointer", fontFamily: sans }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 13.5, fontWeight: 600, color: C.g900 }}>{t.name}</span>
                {t.unread && <span style={{ width: 8, height: 8, borderRadius: "50%", background: C.gold }} />}
              </div>
              <div style={{ fontSize: 11.5, color: C.g400, marginTop: 2 }}>{t.sub}</div>
            </button>
          ))}
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 400 }}>
          <div style={{ padding: "14px 22px", borderBottom: `1px solid ${C.g100}`, fontSize: 14, fontWeight: 600, color: C.g900 }}>{thread.name}</div>
          <div style={{ flex: 1, padding: 22, display: "flex", flexDirection: "column", gap: 12, background: C.g50, overflowY: "auto" }}>
            {thread.messages.map((m, i) => (
              <div key={i} style={{ alignSelf: m.from === "me" ? "flex-end" : "flex-start", maxWidth: "78%" }}>
                <div style={{ padding: "10px 14px", borderRadius: 10, fontSize: 13.5, lineHeight: 1.5, background: m.from === "me" ? C.brand : C.white, color: m.from === "me" ? C.white : C.g900, border: m.from === "me" ? "none" : `1px solid ${C.g100}` }}>{m.text}</div>
                <div style={{ fontSize: 10.5, color: C.g400, marginTop: 4, textAlign: m.from === "me" ? "right" : "left" }}>{m.from === "me" ? "You" : thread.name} · {m.time}</div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, padding: 14, borderTop: `1px solid ${C.g100}` }}>
            <input value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder={`Message ${thread.name}...`} style={{ ...inputStyle, flex: 1 }} />
            <button onClick={send} style={{ ...btnDark, display: "flex", gap: 6, alignItems: "center" }}>{Icon.send} Send</button>
          </div>
        </div>
      </Card>
    </>
  );
}

// ═══════════════════════════════════════════════════
// HANDBOOK
// ═══════════════════════════════════════════════════
function HandbookPage() {
  const [open, setOpen] = useState(0);
  return (
    <>
      <PageTitle title="Member Handbook" sub="How the house works" />
      <Card style={{ marginBottom: 16, padding: "14px 22px", background: C.goldMuted, border: `1px solid ${C.goldMuted}` }}>
        <span style={{ fontSize: 13, color: C.g700 }}>The full Medina Society handbook is being finalized ahead of opening. This is a preview of what it will cover.</span>
      </Card>
      <Card>
        {HANDBOOK.map((h, i) => (
          <div key={i} style={{ borderBottom: i < HANDBOOK.length - 1 ? `1px solid ${C.g100}` : "none" }}>
            <button onClick={() => setOpen(open === i ? -1 : i)} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 22px", background: "none", border: "none", cursor: "pointer", fontFamily: sans, textAlign: "left" }}>
              <span style={{ fontSize: 16, fontFamily: playfair, color: C.g900 }}>{h.title}</span>
              <span style={{ color: C.gold, fontSize: 20, lineHeight: 1 }}>{open === i ? "−" : "+"}</span>
            </button>
            {open === i && <p style={{ padding: "0 22px 18px", fontSize: 13.5, color: C.g500, lineHeight: 1.65 }}>{h.body}</p>}
          </div>
        ))}
      </Card>
    </>
  );
}

// ═══════════════════════════════════════════════════
// SPACES
// ═══════════════════════════════════════════════════
function SpacesPage({ onReserve }) {
  return (
    <>
      <PageTitle title="Spaces" sub="Private rooms available to reserve" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 18 }}>
        {SPACES.map((space, i) => (
          <Card key={i} style={{ overflow: "hidden" }}>
            <img src={space.img} alt={space.name} style={{ width: "100%", height: 220, objectFit: "cover", display: "block" }} />
            <div style={{ padding: 20 }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: C.gold, letterSpacing: 1.5, marginBottom: 6 }}>{space.tag}</div>
              <div style={{ fontSize: 20, color: C.g900, marginBottom: 8, fontFamily: playfair }}>{space.name}</div>
              <p style={{ fontSize: 13, color: C.g500, lineHeight: 1.55, marginBottom: 16 }}>{space.desc}</p>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, color: C.g400 }}>Up to {space.capacity} guests</span>
                <button onClick={() => onReserve(space)} style={btnDark}>Reserve</button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════
// SETTINGS (live password change)
// ═══════════════════════════════════════════════════
function SettingsPage({ user, api }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState(null);

  const submit = async () => {
    if (next.length < 8) return setStatus({ ok: false, msg: "New password must be at least 8 characters." });
    if (next !== confirm) return setStatus({ ok: false, msg: "New passwords don't match." });
    try {
      await api("/api/auth/change-password", { method: "POST", body: JSON.stringify({ currentPassword: cur, newPassword: next }) });
      setStatus({ ok: true, msg: "Password updated." });
      setCur(""); setNext(""); setConfirm("");
    } catch (e) {
      setStatus({ ok: false, msg: e.message === "Session expired" ? "Session expired. Please sign in again." : "Current password is incorrect." });
    }
  };

  return (
    <>
      <PageTitle title="Settings" sub="Your account" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 18 }}>
        <Card>
          <CardHeader title="Profile" icon={Icon.gear} />
          <div style={{ padding: "8px 22px 14px" }}>
            {[["Name", `${user?.firstName || ""} ${user?.lastName || ""}`], ["Email", user?.email], ["Member No.", "001"], ["Member since", "January 2025"]].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "11px 0", borderBottom: `1px solid ${C.g100}` }}>
                <span style={{ fontSize: 13, color: C.g400 }}>{k}</span>
                <span style={{ fontSize: 13, color: C.g900, fontWeight: 500 }}>{v}</span>
              </div>
            ))}
            <p style={{ fontSize: 12, color: C.g400, marginTop: 12 }}>To update your profile details, send a note to Member Services.</p>
          </div>
        </Card>
        <Card>
          <CardHeader title="Change Password" icon={Icon.gear} />
          <div style={{ padding: 22 }}>
            {[["Current password", cur, setCur], ["New password", next, setNext], ["Confirm new password", confirm, setConfirm]].map(([label, val, set]) => (
              <div key={label} style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>{label}</label>
                <input type="password" value={val} onChange={e => { set(e.target.value); setStatus(null); }} style={inputStyle} />
              </div>
            ))}
            {status && <div style={{ fontSize: 13, marginBottom: 12, color: status.ok ? C.green : C.red }}>{status.msg}</div>}
            <button onClick={submit} disabled={!cur || !next || !confirm} style={{ ...btnDark, width: "100%", opacity: !cur || !next || !confirm ? 0.5 : 1 }}>Update Password</button>
          </div>
        </Card>
      </div>
    </>
  );
}

export default function MemberDashboard() {
  const { api, logout, user, token } = useAuth();
  const [page, setPage] = useState("home");
  const [staffMsg, setStaffMsg] = useState("");
  const [docs, setDocs] = useState([]);
  const [reserveSpace, setReserveSpace] = useState(null);
  const [reserveDate, setReserveDate] = useState("");
  const [reserveTime, setReserveTime] = useState("");
  const [reserveGuests, setReserveGuests] = useState("");
  const [reserveNotes, setReserveNotes] = useState("");
  const [reserveConfirmed, setReserveConfirmed] = useState(false);
  const [rsvps, setRsvps] = useState([]);
  const [threads, setThreads] = useState(INITIAL_THREADS);
  const [notice, setNotice] = useState("");
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth < 860);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 860);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  useEffect(() => { if (!notice) return; const t = setTimeout(() => setNotice(""), 3500); return () => clearTimeout(t); }, [notice]);
  useEffect(() => { window.scrollTo(0, 0); }, [page]);

  const toggleRsvp = id => {
    const going = rsvps.includes(id);
    setRsvps(r => going ? r.filter(x => x !== id) : [...r, id]);
    const ev = EVENTS.find(e => e.id === id);
    setNotice(going ? `RSVP cancelled for ${ev.title}` : `You're attending ${ev.title}`);
  };
  const unreadCount = threads.filter(t => t.unread).length;
  const sendStaffMsg = () => {
    if (!staffMsg.trim()) return;
    const text = staffMsg.trim();
    setThreads(ts => ts.map(t => t.id === "concierge" ? { ...t, messages: [...t.messages, { from: "me", text, time: "Just now" }, { from: "staff", text: "Thank you. A member of our team will follow up with you shortly.", time: "Just now" }] } : t));
    setStaffMsg("");
    setNotice("Message sent to the Concierge");
  };

  useEffect(() => { loadDocs(); }, []);
  const loadDocs = async () => { try { setDocs(await api("/api/documents")); } catch(e) {} };

  const download = async (doc) => {
    const res = await fetch(`/api/documents/${doc.id}/download`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = doc.originalName; a.click();
    window.URL.revokeObjectURL(url);
  };

  const fmtDate = d => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  const fmtSize = b => b > 1048576 ? `${(b/1048576).toFixed(1)} MB` : `${Math.round(b/1024)} KB`;

  const navItems = [
    { id: "home", icon: Icon.grid, label: "Dashboard" },
    { id: "events", icon: Icon.calendar, label: "Events" },
    { id: "locker", icon: Icon.wine, label: "My Locker" },
    { id: "dues", icon: Icon.dollar, label: "Dues" },
    { id: "documents", icon: Icon.file, label: "Documents" },
    { id: "messages", icon: Icon.chat, label: "Messages" },
    { id: "handbook", icon: Icon.book, label: "Handbook" },
    { id: "spaces", icon: Icon.home, label: "Spaces" },
    { id: "settings", icon: Icon.gear, label: "Settings" },
  ];

  const firstName = user?.firstName || "David";
  const initials = `${(user?.firstName || "D")[0]}${(user?.lastName || "C")[0]}`;

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: sans, background: C.g50 }}>
      {/* Mobile top bar */}
      {isMobile && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 20, background: C.brand }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 30, height: 30, border: `1.5px solid ${C.gold}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontSize: 15, color: C.gold, fontFamily: playfair }}>M</span>
              </div>
              <span style={{ fontSize: 13, color: C.white, fontFamily: playfair, letterSpacing: 2 }}>MEDINA</span>
            </div>
            <button onClick={logout} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.5)", fontSize: 12, fontFamily: sans, cursor: "pointer" }}>Sign Out</button>
          </div>
          <div style={{ display: "flex", overflowX: "auto", gap: 4, padding: "0 10px 10px", WebkitOverflowScrolling: "touch" }}>
            {navItems.map(item => (
              <button key={item.id} onClick={() => setPage(item.id)} style={{ flexShrink: 0, padding: "7px 12px", borderRadius: 16, border: "none", background: page === item.id ? C.gold : "rgba(255,255,255,0.06)", color: page === item.id ? C.brand : "rgba(255,255,255,0.7)", fontSize: 12.5, fontWeight: 600, fontFamily: sans, cursor: "pointer" }}>
                {item.label}{item.id === "messages" && unreadCount > 0 ? ` (${unreadCount})` : ""}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Sidebar */}
      <aside style={{ width: 220, background: C.brand, display: isMobile ? "none" : "flex", flexDirection: "column", justifyContent: "space-between", position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 10 }}>
        <div>
          <div style={{ padding: "28px 20px 32px", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 38, height: 38, border: `1.5px solid ${C.gold}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontSize: 19, color: C.gold, fontFamily: playfair }}>M</span>
              </div>
              <div>
                <div style={{ fontSize: 15, color: C.white, fontFamily: playfair, letterSpacing: 2.5, fontWeight: 500 }}>MEDINA</div>
                <div style={{ fontSize: 9, color: C.gold, letterSpacing: 3.5, marginTop: 1 }}>MEMBERS CLUB</div>
              </div>
            </div>
          </div>
          <nav style={{ padding: "16px 10px", display: "flex", flexDirection: "column", gap: 1 }}>
            {navItems.map(item => (
              <button key={item.id} onClick={() => setPage(item.id)} style={{
                display: "flex", alignItems: "center", gap: 11, padding: "10px 12px", borderRadius: 8,
                border: "none", background: page === item.id ? C.goldMuted : "transparent",
                color: page === item.id ? C.white : "rgba(255,255,255,0.45)",
                fontSize: 13.5, fontWeight: 500, cursor: "pointer", width: "100%", textAlign: "left", fontFamily: sans,
              }}>
                <span style={{ display: "flex", color: page === item.id ? C.gold : "rgba(255,255,255,0.3)" }}>{item.icon}</span>
                {item.label}
                {item.id === "messages" && unreadCount > 0 && <span style={{ marginLeft: "auto", width: 18, height: 18, borderRadius: "50%", background: C.gold, color: C.brand, fontSize: 10, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{unreadCount}</span>}
              </button>
            ))}
          </nav>
        </div>
        <div style={{ padding: "16px 14px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 34, height: 34, borderRadius: 8, background: `linear-gradient(135deg, ${C.gold}, ${C.goldDark})`, color: C.brand, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700 }}>{initials}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: C.white }}>{user?.firstName} {user?.lastName}</div>
              <div style={{ fontSize: 10, color: C.gold, letterSpacing: 1.5, marginTop: 1 }}>MEMBER 001</div>
            </div>
          </div>
          <button onClick={logout} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: 6, border: "none", background: "rgba(255,255,255,0.03)", color: "rgba(255,255,255,0.3)", fontSize: 12, width: "100%", textAlign: "left", fontFamily: sans, cursor: "pointer" }}>{Icon.logout}<span>Sign Out</span></button>
        </div>
      </aside>

      <main style={{ flex: 1, marginLeft: isMobile ? 0 : 220, paddingTop: isMobile ? 104 : 0, minHeight: "100vh", minWidth: 0 }}>
        <header style={{ display: isMobile ? "none" : "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 36px", background: C.white, borderBottom: `1px solid ${C.g100}`, position: "sticky", top: 0, zIndex: 5 }}>
          <span style={{ fontSize: 13, color: C.g400, letterSpacing: 0.5 }}>
            {new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
          </span>
          <button style={{ width: 36, height: 36, borderRadius: 8, border: `1px solid ${C.g200}`, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", color: C.g500, position: "relative" }}>
            {Icon.bell}
            <div style={{ position: "absolute", top: 7, right: 7, width: 7, height: 7, borderRadius: "50%", background: C.red, border: `2px solid ${C.white}` }} />
          </button>
        </header>

        {page !== "home" && (
          <div style={{ padding: isMobile ? "20px 16px" : "28px 36px", maxWidth: 1100 }}>
            {page === "events" && <EventsPage rsvps={rsvps} toggleRsvp={toggleRsvp} />}
            {page === "locker" && <LockerPage notify={setNotice} />}
            {page === "dues" && <DuesPage notify={setNotice} />}
            {page === "documents" && <DocumentsPage docs={docs} download={download} fmtDate={fmtDate} fmtSize={fmtSize} />}
            {page === "messages" && <MessagesPage threads={threads} setThreads={setThreads} isMobile={isMobile} />}
            {page === "handbook" && <HandbookPage />}
            {page === "spaces" && <SpacesPage onReserve={setReserveSpace} />}
            {page === "settings" && <SettingsPage user={user} api={api} />}
          </div>
        )}

        {page === "home" && (
        <div style={{ padding: isMobile ? "20px 16px" : "28px 36px", maxWidth: 1100 }}>
          {/* Welcome */}
          <div style={{ marginBottom: 24 }}>
            <h1 style={{ fontSize: 28, fontWeight: 400, color: C.g900, fontFamily: playfair, marginBottom: 4 }}>
              Welcome, <span style={{ color: C.brand }}>{firstName}</span>
            </h1>
            <p style={{ fontSize: 14, color: C.g400 }}>Member No. <span style={{ color: C.gold, fontWeight: 600 }}>001</span> · Member since January 2025</p>
          </div>

          {/* Dues Alert */}
          <Card style={{ marginBottom: 20, border: `1px solid ${C.amberSoft}`, background: C.amberBg }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 22px" }}>
              <span style={{ color: C.amber, display: "flex" }}>{Icon.alert}</span>
              <span style={{ flex: 1, fontSize: 13.5, fontWeight: 500, color: C.g900 }}>
                Monthly dues of <strong>$8,500</strong> are due on <strong>November 1, 2026</strong>
              </span>
              <button onClick={() => setPage("dues")} style={{ padding: "7px 18px", borderRadius: 6, border: "none", background: C.brand, color: C.white, fontSize: 12.5, fontWeight: 600, fontFamily: sans, cursor: "pointer" }}>Pay Now</button>
            </div>
          </Card>

          {/* Renewal Alert */}
          <Card style={{ marginBottom: 24, border: "1px solid rgba(58,123,213,0.15)", background: C.blueBg }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 22px" }}>
              <span style={{ color: C.blue, display: "flex" }}>{Icon.calendar}</span>
              <span style={{ fontSize: 13.5, color: C.g700 }}>Membership renewal is coming up on <strong style={{ color: C.g900 }}>January 15, 2027</strong></span>
            </div>
          </Card>

          {/* Main Grid */}
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 18 }}>

            {/* Locker — full width */}
            <Card style={{ gridColumn: "1 / -1" }}>
              <CardHeader title="My Locker" icon={Icon.wine} actionLabel="Manage" action={() => setPage("locker")} />
              <div style={{ padding: "16px 22px", display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(5, 1fr)", gap: 14 }}>
                {LOCKER.map((item, i) => {
                  const pct = item.unit === "%" ? item.remaining : item.remaining > 2 ? 80 : Math.max(item.remaining * 30, 15);
                  const isLow = (item.unit === "%" && item.remaining <= 30) || (item.unit === "btl" && item.remaining <= 1);
                  return (
                    <div key={i} style={{ padding: "14px 12px", borderRadius: 8, background: C.g50, border: isLow ? `1px solid ${C.amberSoft}` : "1px solid transparent" }}>
                      <div style={{ fontSize: 12, color: C.g400, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.8, fontWeight: 500 }}>{item.type}</div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: C.g900, marginBottom: 10, lineHeight: 1.3 }}>{item.name}</div>
                      <LockerBar pct={pct} />
                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
                        <span style={{ fontSize: 11, color: C.g400 }}>{item.remaining}{item.unit === "%" ? "%" : ` ${item.unit}`}</span>
                        {isLow && <span style={{ fontSize: 10, fontWeight: 600, color: C.amber }}>LOW</span>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card>

            {/* ── SPACES ────────────────── */}
            <Card style={{ gridColumn: "1 / -1" }}>
              <CardHeader title="Reserve a Space" icon={<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>} actionLabel="View All" action={() => setPage("spaces")} />
              <div style={{ padding: "20px 22px", display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 16 }}>
                {SPACES.map((space, i) => (
                  <div key={i} style={{ borderRadius: 10, overflow: "hidden", border: `1px solid ${C.g100}`, background: C.white, cursor: "pointer", transition: "transform 0.2s, box-shadow 0.2s" }}
                    onClick={() => setReserveSpace(space)}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.08)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                  >
                    <div style={{ width: "100%", height: 200, overflow: "hidden", position: "relative" }}>
                      <img src={space.img} alt={space.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.5) 100%)" }} />
                    </div>
                    <div style={{ padding: "16px 18px" }}>
                      <div style={{ fontSize: 10, fontWeight: 600, color: C.gold, letterSpacing: 1.5, marginBottom: 6 }}>{space.tag}</div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: C.g900, marginBottom: 8, fontFamily: playfair }}>{space.name}</div>
                      <div style={{ fontSize: 12.5, color: C.g500, lineHeight: 1.5, marginBottom: 14 }}>{space.desc}</div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: 11, color: C.g400 }}>Up to {space.capacity} guests</span>
                        <button style={{ padding: "7px 16px", borderRadius: 6, border: "none", background: C.brand, color: C.white, fontSize: 12, fontWeight: 600, fontFamily: sans }}>Reserve</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card>

            {/* Events */}
            <Card>
              <CardHeader title="Upcoming Events" icon={Icon.calendar} actionLabel="All Events" action={() => setPage("events")} />
              {EVENTS.map((ev, i) => (
                <div key={ev.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 22px", borderBottom: i < EVENTS.length - 1 ? `1px solid ${C.g100}` : "none" }}>
                  <div style={{ width: 44, height: 52, borderRadius: 8, background: C.goldMuted, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <span style={{ fontSize: 16, fontWeight: 700, color: C.gold, lineHeight: 1 }}>{ev.date.split(" ")[1]}</span>
                    <span style={{ fontSize: 10, color: C.goldDark, textTransform: "uppercase", fontWeight: 600 }}>{ev.date.split(" ")[0]}</span>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 500, color: C.g900, marginBottom: 3 }}>{ev.title}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11.5, color: C.g400 }}>
                      <span style={{ display: "flex", alignItems: "center", gap: 3 }}>{Icon.clock} {ev.time}</span><span>·</span><span>{ev.location}</span>
                    </div>
                  </div>
                  <div style={{ textAlign: "right", flexShrink: 0 }}>
                    <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 4, letterSpacing: 0.5, color: tagColor[ev.tag] || C.g600, background: `${tagColor[ev.tag] || C.g400}15` }}>{ev.tag.toUpperCase()}</span>
                    <div style={{ fontSize: 11, color: ev.spots <= 5 ? C.red : C.g400, marginTop: 4 }}>{ev.spots} spots left</div>
                  </div>
                </div>
              ))}
            </Card>

            {/* Right column */}
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              {/* Message Staff */}
              <Card>
                <CardHeader title="Message Staff" icon={Icon.chat} actionLabel="All Messages" action={() => setPage("messages")} />
                <div style={{ padding: "16px 22px" }}>
                  <textarea value={staffMsg} onChange={e => setStaffMsg(e.target.value)} placeholder="Beverage orders, reservations, special requests..." rows={3}
                    style={{ width: "100%", padding: "10px 14px", border: `1px solid ${C.g200}`, borderRadius: 8, fontSize: 13, color: C.g900, background: C.g50, resize: "none", fontFamily: sans, lineHeight: 1.5 }} />
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                    <span style={{ fontSize: 11, color: C.g400 }}>Replies within 10 min</span>
                    <button onClick={sendStaffMsg} style={{ padding: "7px 16px", borderRadius: 6, border: "none", background: C.brand, color: C.white, fontSize: 12.5, fontWeight: 500, fontFamily: sans, display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>{Icon.send} Send</button>
                  </div>
                </div>
              </Card>

              {/* Dues Summary */}
              <Card>
                <CardHeader title="Dues Summary" icon={Icon.dollar} actionLabel="Details" action={() => setPage("dues")} />
                <div style={{ padding: "16px 22px" }}>
                  {[
                    { label: "Monthly Dues", value: "$8,500" },
                    { label: "Status", value: "Current", vc: C.green },
                    { label: "Next Due", value: "November 1, 2026" },
                    { label: "Renewal", value: "January 15, 2027" },
                  ].map((r, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: i < 3 ? `1px solid ${C.g100}` : "none" }}>
                      <span style={{ fontSize: 13, color: C.g400 }}>{r.label}</span>
                      <span style={{ fontSize: 13, fontWeight: 600, color: r.vc || C.g900 }}>{r.value}</span>
                    </div>
                  ))}
                  <button onClick={() => setPage("dues")} style={{ width: "100%", padding: 10, borderRadius: 6, border: "none", background: C.brand, color: C.white, fontSize: 13, fontWeight: 600, fontFamily: sans, marginTop: 12, cursor: "pointer" }}>Pay Dues</button>
                </div>
              </Card>

              {/* Documents */}
              {docs.length > 0 && (
                <Card>
                  <CardHeader title="My Documents" icon={Icon.file} actionLabel="View All" action={() => setPage("documents")} />
                  {docs.slice(0, 3).map((d, i) => (
                    <div key={d.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 22px", borderBottom: i < 2 ? `1px solid ${C.g100}` : "none" }}>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: C.g900 }}>{d.originalName}</div>
                        <div style={{ fontSize: 11, color: C.g400 }}>{fmtDate(d.uploadedAt)} · {fmtSize(d.fileSize)}</div>
                      </div>
                      <button onClick={() => download(d)} style={{ padding: "5px 12px", borderRadius: 5, border: "none", background: C.brand, color: C.white, fontSize: 11, fontWeight: 500, fontFamily: sans }}>Download</button>
                    </div>
                  ))}
                </Card>
              )}

              {/* Handbook */}
              <Card>
                <CardHeader title="Member Handbook" icon={Icon.book} actionLabel="Open" action={() => setPage("handbook")} />
                <div style={{ padding: "16px 22px" }}>
                  <p style={{ fontSize: 13, color: C.g500, lineHeight: 1.5, marginBottom: 14 }}>Club policies, dress code, guest guidelines, and facility hours.</p>
                  <button style={{ width: "100%", padding: 10, borderRadius: 6, border: `1px solid ${C.g200}`, background: C.white, color: C.g900, fontSize: 13, fontWeight: 500, fontFamily: sans, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer" }} onClick={() => setPage("handbook")}>{Icon.book} Read the Handbook</button>
                </div>
              </Card>
            </div>
          </div>
        </div>
        )}
        <Notice text={notice} onClose={() => setNotice("")} />
        {/* ── RESERVATION MODAL ────── */}
        {reserveSpace && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100 }}
            onClick={() => { setReserveSpace(null); setReserveConfirmed(false); }}>
            <div style={{ background: C.white, borderRadius: 14, width: "100%", maxWidth: 480, overflow: "hidden" }}
              onClick={e => e.stopPropagation()}>
              {/* Modal header image */}
              <div style={{ width: "100%", height: 180, overflow: "hidden", position: "relative" }}>
                <img src={reserveSpace.img} alt={reserveSpace.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, transparent 30%, rgba(0,0,0,0.6) 100%)" }} />
                <div style={{ position: "absolute", bottom: 16, left: 20, zIndex: 2 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: C.gold, letterSpacing: 1.5, marginBottom: 4 }}>{reserveSpace.tag}</div>
                  <div style={{ fontSize: 22, fontWeight: 500, color: C.white, fontFamily: playfair }}>{reserveSpace.name}</div>
                </div>
                <button onClick={() => { setReserveSpace(null); setReserveConfirmed(false); }}
                  style={{ position: "absolute", top: 12, right: 12, width: 32, height: 32, borderRadius: "50%", background: "rgba(0,0,0,0.4)", border: "none", color: C.white, fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 2 }}>×</button>
              </div>

              {!reserveConfirmed ? (
                <div style={{ padding: "24px 24px 28px" }}>
                  <p style={{ fontSize: 13, color: C.g500, lineHeight: 1.5, marginBottom: 20 }}>{reserveSpace.desc}</p>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>Date</label>
                      <input type="date" value={reserveDate} onChange={e => setReserveDate(e.target.value)}
                        style={{ width: "100%", padding: "10px 12px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, fontFamily: sans }} />
                    </div>
                    <div>
                      <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>Time</label>
                      <select value={reserveTime} onChange={e => setReserveTime(e.target.value)}
                        style={{ width: "100%", padding: "10px 12px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, fontFamily: sans, background: C.white }}>
                        <option value="">Select time</option>
                        <option>10:00 AM</option><option>11:00 AM</option><option>12:00 PM</option>
                        <option>1:00 PM</option><option>2:00 PM</option><option>3:00 PM</option>
                        <option>4:00 PM</option><option>5:00 PM</option><option>6:00 PM</option>
                        <option>7:00 PM</option><option>8:00 PM</option><option>9:00 PM</option>
                      </select>
                    </div>
                  </div>
                  <div style={{ marginBottom: 14 }}>
                    <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>Number of Guests (max {reserveSpace.capacity})</label>
                    <input type="number" min="1" max={reserveSpace.capacity} value={reserveGuests} onChange={e => setReserveGuests(e.target.value)}
                      placeholder={`1-${reserveSpace.capacity}`}
                      style={{ width: "100%", padding: "10px 12px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, fontFamily: sans }} />
                  </div>
                  <div style={{ marginBottom: 20 }}>
                    <label style={{ fontSize: 12, fontWeight: 500, color: C.g700, display: "block", marginBottom: 6 }}>Special Requests</label>
                    <textarea value={reserveNotes} onChange={e => setReserveNotes(e.target.value)}
                      placeholder="Beverage preferences, AV needs, catering requests..."
                      rows={3}
                      style={{ width: "100%", padding: "10px 12px", border: `1px solid ${C.g200}`, borderRadius: 6, fontSize: 14, fontFamily: sans, resize: "none", lineHeight: 1.5 }} />
                  </div>
                  <button onClick={() => setReserveConfirmed(true)}
                    style={{ width: "100%", padding: 13, borderRadius: 8, border: "none", background: C.brand, color: C.white, fontSize: 14, fontWeight: 600, fontFamily: sans }}>
                    Request Reservation
                  </button>
                </div>
              ) : (
                <div style={{ padding: "40px 24px", textAlign: "center" }}>
                  <div style={{ width: 48, height: 48, borderRadius: "50%", background: "rgba(59,155,94,0.08)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                    <svg width="24" height="24" fill="none" stroke="#3B9B5E" strokeWidth="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <h3 style={{ fontSize: 20, fontWeight: 400, color: C.g900, fontFamily: playfair, marginBottom: 8 }}>Reservation Requested</h3>
                  <p style={{ fontSize: 13, color: C.g500, lineHeight: 1.5, marginBottom: 20 }}>
                    Your request for the {reserveSpace.name} has been submitted. Our team will confirm your reservation shortly.
                  </p>
                  <button onClick={() => { setReserveSpace(null); setReserveConfirmed(false); setReserveDate(""); setReserveTime(""); setReserveGuests(""); setReserveNotes(""); }}
                    style={{ padding: "10px 28px", borderRadius: 6, border: `1px solid ${C.g200}`, background: C.white, color: C.g900, fontSize: 13, fontWeight: 500, fontFamily: sans }}>
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
